import React, { Children, Component } from 'react';
import { useSequenceStore } from '~/training/sequence/SequenceStore';
import { QUESTION_SEQUENCE } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { useEditorStore, getEditorState } from '~/shell/Store';

export type QuestionSequenceDefinition = ItemDefinition<
  typeof QUESTION_SEQUENCE,
  void
>;

/**
 * This item is a bit special: it is meant to be used with children that
 * have each been created from a question.
 * It will render answered questions as well as the next question to be answered.
 */
export class QuestionSequence extends Item<typeof QUESTION_SEQUENCE, void> {
  protected render({ children }: RenderProps<void>) {
    const { editorMode } = useEditorStore.getState();

    const answers = useSequenceStore(s => s.answers);

    const childArray = Children.toArray(children) as Array<
      Component<RenderProps<void>>
    >;

    return (
      <>
        {editorMode
          ? childArray.filter((c, i) => {
              return true;
            })
          : childArray.filter((c, i) => {
              return (
                i === 0 || answers[childArray[i - 1].props.id] !== undefined
              );
            })}
      </>
    );
  }
}

registry[QUESTION_SEQUENCE] = QuestionSequence;
